/** Brand assets for dark kiosk shells (Vite `public/`). */
export const brandAssets = {
  monitorIcon: '/ghost-screen-white-on-black.svg',
  wordmark: '/ghostscreens-wordmark.svg',
} as const;
